import { Box, Button, Popover, TextField } from "@mui/material";
import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import FlexBox from "../../../layouts/Flexbox";
import dayjs from "dayjs";
import "react-day-picker/style.css";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { CustomSelectDropdown } from "./CustomDropdown";

export default function DateRangePicker({ value, onSelect, placeholder = "" }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleDateClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDateClose = () => {
    setAnchorEl(null);
  };

  const handleDateSelect = (selectedDate) => {
    onSelect(selectedDate);
  };

  return (
    <React.Fragment>
      <TextField
        value={
          value
            ? `${dayjs(value?.from).format("MM/DD/YYYY")} - ${dayjs(
                value?.to
              ).format("MM/DD/YYYY")}`
            : ""
        }
        onClick={handleDateClick}
        placeholder={placeholder}
        fullWidth
        sx={{ bgcolor: "white" }}
        InputProps={{
          readOnly: true,
          endAdornment: <InsertInvitationIcon />,
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleDateClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box p={2}>
          <DayPicker
            mode="range"
            components={{ Dropdown: CustomSelectDropdown }}
            numberOfMonths={1}
            captionLayout="dropdown"
            selected={value}
            onSelect={handleDateSelect}
          />
          <FlexBox justifyContent={"space-between"} mt={1}>
            <Button
              color="secondary"
              fullWidth={false}
              onClick={() => handleDateSelect(null)}
            >
              Clear
            </Button>

            <Button onClick={handleDateClose} fullWidth={false}>
              Ok
            </Button>
          </FlexBox>
        </Box>
      </Popover>
    </React.Fragment>
  );
}
